import { useState } from 'react'

// Merge saved prefs over defaults so newly added columns get their default
// visibility instead of disappearing for users with older saved prefs.
export function loadColumns(storageKey, defaults) {
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey))
    return saved ? { ...defaults, ...saved } : defaults
  } catch {
    return defaults
  }
}

export function useColumnPrefs(storageKey, defaults) {
  const [columns, setColumns] = useState(() => loadColumns(storageKey, defaults))

  function toggle(key) {
    setColumns(c => {
      const next = { ...c, [key]: !c[key] }
      try { localStorage.setItem(storageKey, JSON.stringify(next)) } catch { /* ignore */ }
      return next
    })
  }

  function reset() {
    setColumns(defaults)
    try { localStorage.removeItem(storageKey) } catch { /* ignore */ }
  }

  const isDefault = Object.keys(defaults).every(k => columns[k] === defaults[k])

  return { columns, toggle, reset, isDefault }
}
